var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateApplications = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 41,
    viewBox: "0 0 50 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3H40C40.5523 3 41 3.44772 41 4V17H38C35.7909 17 34 18.7909 34 21V24H7V4C7 3.44772 7.44771 3 8 3ZM34 27H7H4L3 27V29H34V27ZM34 32H2C0.895431 32 0 31.1046 0 30V26C0 24.8954 0.895431 24 2 24L4 24V4C4 1.79086 5.79086 0 8 0H40C42.2091 0 44 1.79086 44 4V17H46C48.2091 17 50 18.7909 50 21V37C50 39.2091 48.2091 41 46 41H38C35.7909 41 34 39.2091 34 37V32ZM38 20H46C46.5523 20 47 20.4477 47 21V37C47 37.5523 46.5523 38 46 38H38C37.4477 38 37 37.5523 37 37V21C37 20.4477 37.4477 20 38 20Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateApplications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateApplications.6cf04785c2206381e5acc655c6300214.svg";